import React from "react";
import EditorShell from "../EditorShell";
import { TextField, TextareaField } from "../fields";
import StringListEditor from "../StringListEditor";
import { privateByDesignSchema, SECTION_DEFAULTS } from "../schemas";

const PrivateByDesignEditor = ({ section, onSaved, onLiveChange }) => (
  <EditorShell
    sectionKey="private_by_design"
    schema={privateByDesignSchema}
    defaults={SECTION_DEFAULTS.private_by_design}
    section={section}
    onSaved={onSaved}
    onLiveChange={onLiveChange}
  >
    {(form) => (
      <>
        <TextField form={form} path="title" label="Section title" />
        <TextareaField
          form={form}
          path="description"
          label="Description"
          rows={2}
        />
        <StringListEditor
          form={form}
          name="bullets"
          label="Privacy bullets"
          placeholder="Your data belongs to you."
          max={8}
          hint="Each bullet renders with a green check on the dark privacy card."
        />
      </>
    )}
  </EditorShell>
);

export default PrivateByDesignEditor;
